import { FC } from 'react';

import { ToolFavoriteProps } from '../types';
import { IconStarRegular } from './icon-star-regular';
import { IconStarSolid } from './icon-star-solid';

export const ToolFavorite: FC<ToolFavoriteProps> = ({ toolCatalogId, isToolFavorite, onFavoriteChange }) => {
  return isToolFavorite ? (
    <IconStarSolid
      handleClick={() => {
        onFavoriteChange(toolCatalogId, !isToolFavorite);
      }}
    />
  ) : (
    <IconStarRegular
      handleClick={() => {
        onFavoriteChange(toolCatalogId, !isToolFavorite);
      }}
    />
  );
};
